var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPractice = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 4a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h5.5a1 1 0 1 0 0-2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v3.5a1 1 0 1 0 2 0V8a4 4 0 0 0-4-4H6Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.865 13.27c-1.088-.335-2.1.7-1.74 1.78l2.219 6.655c.42 1.26 2.194 1.282 2.645.033l1.041-2.885L21.607 18c1.294-.428 1.274-2.267-.029-2.667l-6.713-2.064Zm1.83 6.163-1.304-3.91 3.802 1.17-1.068.353a1.4 1.4 0 0 0-.877.854l-.553 1.533Z",
  fill: "currentColor"
})));
export default SvgPractice;